export default __webpack_public_path__ + "static/media/EstudiantesIes_scroll.f904242f.png";